<script>
	import {
		SHARE_UID,
		APP_PUSH_OPEN_PAGE
	} from './config/cache.js'
	import {
		postAppPush
	} from '@/common/api.js'
	import Cache from './utils/cache.js'

	export default {
		onLaunch: function(query) {
			console.log('App Launch', query)
			console.log('HOST_URL', import.meta.env.VITE_APP_HOST_URL)
			console.log('SYS_ID', import.meta.env.VITE_APP_SYS_ID)
			console.log('运行环境', import.meta.env.VITE_USER_NODE_ENV)
			console.log('MP版本号', import.meta.env.VITE_APP_APP_VERSION)
			// #ifdef APP-PLUS
			console.log('APP版本号名称', import.meta.env.VITE_APP_APP_VERSION)
			console.log('APP版本号名称', plus.runtime.version)
			// #endif




			// #ifdef MP
			if (query.query && query.query.uid) {
				Cache.set(SHARE_UID, query.query.uid, 60 * 60 * 24 * 7)
			}
			// #endif
			// #ifdef H5
			let userToken = document.cookie.match(`[;\s+]?userToken=([^;]*)`)?.pop()
			if (userToken) {
				this.$store.commit("setUserToken", userToken)
			}
			let uid = this.xc.getQueryParam('uid')
			if (typeof uid !== 'undefined' && uid) {
				Cache.set(SHARE_UID, uid, 60 * 60 * 24 * 7)
			}
			// #endif
			// this.$store.commit("setUserToken",
			// 	'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJoNSIsInN1YiI6MSwiaWF0IjoxNjgyMjE3NDk5LCJleHAiOjE2ODQ4MDk0OTksIm5iZiI6MTY4MjIxNzQ5OSwianRpIjoiZjM5MTQzMzU4ODk2OGU4ZDY0M2RhYWYxZjEyNjBiMDUifQ.2RkVp9p5ndLVxTUzLD9UfZSW4CsexSZGvA0rDj6NSJQ'
			// )
			// #ifdef APP-PLUS
			try {
				uni.onPushMessage((res) => {
					console.log("收到推送消息：", res) //监听推送消息
					postAppPush({
						data: {
							data: JSON.stringify(res)
						}
					})
					const data = res.data ? res.data : {}
					if (typeof data.aps === 'object') {
						//设置标角
						var badge = typeof data.aps.badge === 'number' ? data.aps.badge : 0
						var badge_num = badge > 0 ? (badge - 1) : 0
						plus.runtime.setBadgeNumber(badge_num)
					}
					//参数
					if (typeof data.payload === 'object') {
						//判断是否有path参数
						if (data.payload.path) {
							//将跳转链接缓存 在首页进度读取跳转
							Cache.set(APP_PUSH_OPEN_PAGE, data.payload, 3600)
						}

					}
				})
			} catch (e) {
				//TODO handle the exception
			}
			// #endif

			//#ifdef MP
			const updateManager = uni.getUpdateManager();
			updateManager.onCheckForUpdate(function(res) {
				// 请求完新版本信息的回调
				console.log(res.hasUpdate);
			});
			updateManager.onUpdateReady(function(res) {
				uni.$xc.modal('发现新版本，为了获得更好的体验，建议立即更新', '更新提示', (res) => {
					updateManager.applyUpdate();
				})
			})
			updateManager.onUpdateFailed(function(res) {
				uni.$xc.modal('新版本更新失败，请稍后再试或删除小程序重新搜索打开', '更新失败');
			})
			// #endif
			// #ifdef H5
			uni.getSystemInfo({
				success(e) {
					/* 窗口宽度大于420px且不在PC页面且不在移动设备时跳转至 PC.html 页面 */
					if (e.windowWidth > 420 && !window.top.isPC && !/iOS|Android/i.test(e.system)) {
						const path = window.location.pathname;
						// 获取当前页面的查询参数
						const searchParams = window.location.search;
						// 获取当前页面的片段标识符（hash）
						const hashFragment = window.location.hash;
						// 输出这些部分
						let url = ''
						if (path) {
							url += path
						}
						if (searchParams) {
							url += searchParams
						}
						if (hashFragment) {
							url += hashFragment
						}
						if (!url) {
							url = '/'
						}
						//缓存打开的链接 
						uni.setStorageSync('pc_url', encodeURIComponent(url))
						window.location.pathname = `/web/mailingTool/static/h5/html/pc.html`;
					}
				}
			})
			// if (option.query.hasOwnProperty('type') && option.query.type == "iframeWindow") {
			// 	this.globalData.isIframe = true;
			// } else {
			// 	this.globalData.isIframe = false;
			// }
			// #endif
			console.log('执行', 'getAppConfig')

			this.$store.dispatch('getAppConfig', {
				cache: true
			})
			console.log('执行', 'reqChatUnreadNum')
			//未读消息数 寄信助手无需
			// this.$store.dispatch('reqChatUnreadNum', {
			// 	data: {},
			// 	cache: true
			// })
			this.$store.dispatch('getOrderStatusNum', false)
		},
		onLoad(e) {
			console.log('触发全局onload', e)
		},
		onShow: function(query) {
			console.log('getCurrentPages', getCurrentPages())
			let pageLen = getCurrentPages().length
			if (pageLen === 0 || pageLen === 1) {
				this.$store.commit("setIsHome", true)
			}
			console.log('启动参数', query)
			// #ifdef MP
			if (query.query && query.query.uid) {
				uni.setStorageSync(SHARE_UID, query.query.uid, 60 * 60 * 24 * 7)
			}
			// #endif
			this.$store.dispatch('getUserInfo')
		},
		mounted() {},
		onHide: function() {
			console.log('App Hide')
		},
		onThemeChange: function(res) {
			console.log('主题切换', res)
			// 主题切换时更新 store 中的主题信息
			this.$store.commit('setTheme', res.theme)
		}
	}
</script>
<style lang="scss">
	/* #ifdef H5 */
	uni-modal {
		z-index: 1999 !important;
	}

	uni-toast {
		z-index: 1999 !important;
	}

	/* #endif */
</style>
<style>
	/*每个页面公共css */
	@import './common/fui-app.css';
	@import './fui-theme.css';
	/*自定义字体css */
	/* @import './static/icon/fui-custom-icon.css'; */

	page {
		--button-color-del: red;
		--button-color-empty: #8BC0B9;


		--fui-color-primary: red;

		--font-gray: #B2B2B2;
		--font-gray-def: #cccccc;
		--font-price-tip: rgba(0, 0, 0, .6);

		--list-active: linear-gradient(135deg, #7167ed, #be5ff4);
		/* 	background-image: -webkit-linear-gradient(bottom, #fed6e3, #a8edea); */
		/* 		background-image: linear-gradient(300deg,#fed6e3, #a8edea); */
		/* 	background-image: url('https://cloud-minapp-43183.cloud.ifanrusercontent.com/1oR88fndqXX1KD2e.png'); */
		background-repeat: no-repeat;
		background-size: 100%;
	}
</style>
<style lang="scss">
	/* 公共工具类样式 */
	@import './common/styles/utils.scss';

	.send-address {
		text-align: center;
		align-items: center;
		display: flex;
		flex-direction: column;

		.body {
			display: flex;
			padding: 20rpx;

			.select {
				color: #4071FF;
				font-size: 40rpx;
			}
		}
	}

	//收货地址
	.address-body {
		padding: 10rpx;
		-webkit-user-select: auto !important;
		-moz-user-select: auto !important;
		-ms-user-select: auto !important;
		user-select: auto !important;

		.top {
			.name {
				font-size: 40rpx;
				display: inline-block;
			}

			.phone {
				font-size: 30rpx;
				display: inline-block;
			}
		}

		.price {
			font-size: 30rpx;
			color: red;
		}


		.address {
			@include text-ellipsis-two(2);
			font-size: 24rpx;
		}
	}
</style>
<style lang="less">
	/* 工具类样式已移至 common/styles/utils.scss */



	.fui-popup__container {
		background-color: #f7f7f7;
		width: 100%;
		position: relative;
		display: flex;
		justify-content: center;
		flex-direction: column;
		padding: 24rpx 0rpx;
		// box-sizing: border-box;

		.fui-title {
			font-size: 30rpx;
			font-weight: bold;
			text-align: center;
		}

		.fui-sub__title {
			/* #ifndef APP-NVUE */
			display: block;
			/* #endif */
			text-align: center;
			font-size: 24rpx;
			color: #7F7F7F;
			transform: scale(.9);
		}

		.list {
			max-height: 70vh;
			background-color: #fff;

			box-sizing: border-box;
		}


		.fui-icon__close {
			position: absolute;
			top: 24rpx;
			right: 24rpx;
		}
	}




	//协议勾选
	.fui-clause--cell {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24rpx;
	}

	.fui-clause--wrap {
		width: 100%;
		margin-top: 32rpx;
	}


	.fui-clause--text {
		color: var(--font-price-tip);
		padding-left: 16rpx;
		/* #ifdef H5 */
		cursor: pointer;
		/* #endif */
	}

	.fui-color__link {
		color: var(--fui-color-link);
		/* #ifdef H5 */
		cursor: pointer;
		/* #endif */
	}

	.panel-list {
		margin-top: 30rpx;
		width: 100%;
	}

	/* .text-copy 已移至 common/styles/utils.scss */



	.fui-scroll__wrap {
		padding-top: 30rpx;
		position: relative;
	}

	.fui-calendar-title {
		font-size: 30rpx;
		font-weight: bold;
		text-align: center;
		padding-bottom: 24rpx;
	}

	.fui-icon__close {
		position: absolute;
		top: 24rpx;
		right: 24rpx;
	}




	//抖动
	.shake-agent {
		animation-name: shake;
		animation-duration: 0.5s;
		// animation-iteration-count: infinite;
		animation-iteration-count: 1;
	}

	@keyframes shake {
		0% {
			transform: translateX(0);
		}

		25% {
			transform: translateX(-10px);
		}

		50% {
			transform: translateX(10px);
		}

		75% {
			transform: translateX(-10px);
		}

		100% {
			transform: translateX(0);
		}
	}




	// 导航栏
	.fui-nav__left {
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		flex-direction: row;
		width: 150rpx;
		justify-content: flex-start;
		align-items: center;
	}

	.fui-nav__right {
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		flex-direction: row;
		width: 150rpx;
		justify-content: flex-end;
		align-items: center;
	}

	.fui-nav__title {
		flex: 1;
		/* #ifndef APP-NVUE */
		display: flex;
		box-sizing: border-box;
		/* #endif */
		flex-direction: row;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		padding: 0 30rpx;
	}



	/* .flex, .jc-between, .align-items-end, .align-items-center 已移至 common/styles/utils.scss */
</style>